import { TbPercentage } from "react-icons/tb";
import InfoStatCard, { InfoStatCardPeerRow } from "../InfoStatCard/InfoStatCard";
import StatLabelInfoTooltip from "../StatLabelInfoTooltip/StatLabelInfoTooltip";
import StatSplitBar from "../StatSplitBar/StatSplitBar";
import { StudyHabitsPeriod } from "../../constants/dashboardStats";
import SplitToggle, {
  CHART_PERIOD_OPTIONS,
} from "../SplitToggle";
import "./StudyHabitsSection.scss";

type StudyHabitsSectionProps = {
  habits: StudyHabitsPeriod;
  period: 7 | 30;
  onPeriodChange: (period: 7 | 30) => void;
};

const StudyHabitsSection = ({ habits, period, onPeriodChange }: StudyHabitsSectionProps) => {
  const correctPercent = Math.round(
    (habits.correct / (habits.correct + habits.incorrect)) * 100
  );

  return (
    <section className="study-habits-section">
      <div className="study-habits-section__header">
        <h3 className="study-habits-section__title">
          Ranking &amp; study habits (last {period} days)
        </h3>
        <SplitToggle
          value={period}
          onChange={onPeriodChange}
          options={CHART_PERIOD_OPTIONS}
          ariaLabel="Chart time period"
          id="rank"
        />
      </div>
      <div className="study-habits-section__grid">
        <InfoStatCard
          label="Questions done"
          labelInfo={
            <StatLabelInfoTooltip id="study-habits-questions-done-stats-tooltip" />
          }
          value={habits.questionsDone}
          detail={habits.questionsDetail}
          footer={
            <StatSplitBar
              variant="neutral"
              correctPercent={correctPercent}
              correctLabel={`${habits.correct} correct`}
              incorrectLabel={`${habits.incorrect} incorrect`}
            />
          }
        />
        <InfoStatCard
          label={
            <>
              <TbPercentage aria-hidden="true" />
              Avg score
            </>
          }
          labelInfo={
            <StatLabelInfoTooltip id="study-habits-avg-score-stats-tooltip" />
          }
          value={`${habits.avgScore}%`}
          detail={habits.avgScoreDetail}
          footer={<InfoStatCardPeerRow peerAvg={habits.peerAvg} score={habits.avgScore} />}
        />
      </div>
    </section>
  );
};

export default StudyHabitsSection;
